import { render, staticRenderFns } from "./ImportBankStatement.yaml?vue&type=template&id=734015fa&component"
import script from "./ImportBankStatement.yaml?vue&type=script&lang=ts&component"
export * from "./ImportBankStatement.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports